/**
 * The export and caption labels every economics chart carries (download, copy data,
 * data table). Each widget spreads these into its own `*_STRINGS`, so a translated
 * content file can override them per tool like any other string.
 */
export const ECON_CHART_STRINGS = {
  downloadSvg: "Download SVG",
  downloadPng: "Download PNG",
  copyData: "Copy data",
  copied: "Copied!",
  exportFailed:
    "This browser could not create the PNG. Try Download SVG, or another browser.",
  showDataTable: "Show the graph data as a table",
  figureLabel: "Figure {number}",
  noteLabel: "Note.",
  copyCaption: "Copy number and title",
} as const;
